<template>
  <div>
    <div class="row mb-3">
      <div class="col-md-12 text-right">
        <button
            v-if="$can.view($store.getters.getAuthUser, 'create-branches')"
            class="btn btn-primary btn-sm"
            type="button"
            @click.prevent="branchModal(null)"
        >
          <i class="fa fa-bank"></i> Create Branch
        </button>
      </div>
    </div>
    <loading v-if="loading"/>
    <table
        v-else
        ref="table"
        class="table table-striped table-responsive-sm"
    >
      <thead>
      <tr>
        <th>#</th>
        <th>Name</th>
        <th>Actions</th>
      </tr>
      </thead>
      <tbody>
      <tr
          v-for="(item, i) in branches"
          :key="i"
      >
        <td>{{ pagination.from + i }}</td>
        <td>{{ item.name }}</td>
        <td>
          <button
              class="btn btn-sm btn-info"
              title="edit"
              type="button"
              @click.prevent="branchModal(item)"
          >
            <i
                class="fa fa-edit"
            />
          </button>
          <button
              class="btn btn-sm ml-1 btn-danger"
              title="Delete"
              type="button"
              @click.prevent="deleteBranch(item)"
          >
            <i
                class="fa fa-trash"
            />
          </button>
        </td>
      </tr>
      </tbody>
    </table>
    <pagination
        v-if="pagination.last_page > 1"
        :offset="5"
        :pagination="pagination"
        @paginate="fetch"
    />

    <modal
        :show-modal="showModal"
        @close="showModal = false"
    >
      <template v-slot:header>
        <h5 v-if="branch">Edit Branch</h5>
        <h5 v-else>Create Branch</h5>
      </template>
      <form
          @submit.prevent="save()"
      >
        <div v-if="error" v-html="$error.handle(error)"/>
        <div class="row">
          <div class="form-group col-md-8">
            <label>Name</label>
            <input
                v-model="name"
                class="form-control"
                required
                type="text"
            >
          </div>
        </div>
        <div class="form-group">
          <button
              class="btn btn-primary"
              type="submit">
            <span v-if="branch">Update</span>
            <span v-else>Create</span>
          </button>
        </div>
      </form>
    </modal>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import $ from "jquery";

export default {

  data() {
    return {
      loading: false,
      showModal: false,
      branch: {
        name: ''
      },
      name: '',
      error: null,
      pagination: {
        'current_page': 1,
        'last_page': 1,
        'from': 1
      }
    }
  },
  computed: {
    ...mapGetters({
      branches: 'getBranches'
    }),
  },
  watch: {
    branches() {
      if (this.dt) this.dt.destroy();
      setTimeout(() => {
        this.dt = $(this.$refs.table).DataTable();
      }, 1000);
    }
  },
  mounted() {
    setTimeout(() => {
      this.dt = $(this.$refs.table).DataTable();
    }, 1000);
    this.fetch();
  },
  methods: {
    fetch() {
      if (this.branches.length) return;
      this.loading = true;
      this.$store.dispatch("fetchBranches").then(() => {
        this.loading = false;
      });
    },
    save() {
      if (this.branch) {
        this.edit();
        return;
      }
      this.$axios.post('/api/v1/branches', {'name': this.name}).then((response) => {
        this.showModal = false;
        this.fetch();
        this.name = '';
        this.branch = null;
        this.$store.dispatch('setBranch', response.data);
        this.$toastr.s('Branch Created');
      }).catch(error => {
        this.setError(error);
      });
    },
    edit() {
      this.$axios.put(`/api/v1/branches/${this.branch.id}`, {name: this.name}).then((response) => {
        this.$store.dispatch('setBranch', response.data);
        this.showModal = false;
        this.name = '';
        this.branch = null;
        this.$toastr.s('Branch updated');
      }).catch(error => {
        this.setError(error);
      });
    },
    setError(err) {
      this.error = err.response;
      setTimeout(() => {
        this.error = null;
      }, 6000);
    },
    deleteBranch(branch) {
      this.$swal({
        title: 'Are you sure?',
        text: "Are you sure you want to delete the branch " + branch.name + " ?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.value) {
          this.$axios.delete(`/api/v1/branches/${branch.id}`).then(() => {
            this.$store.dispatch('deleteBranch', branch);
            this.$toastr.s('Branch deleted');
          }).catch(error => {
            this.$toastr.w(error.response.data.error);
          });
        }
      })
    },
    branchModal(branch) {
      if (branch != null) {
        this.branch = branch;
        this.name = branch.name;
      } else {
        this.branch = null;
      }
      this.showModal = true;
    }
  }
}
</script>
